export default (section) => {
  console.log(section);
  switch (section) {
    case 'android':
      return [
        "#0fd850",
        "#f9f047",
      ];
    case 'ios':
      return [
        "#0ACFFE",
        "#495AFF",
      ];
    case 'react':
      return [
        "#F6D365",
        "#FDA085",
      ];
    case 'laravel':
      return [
        "#B224EF",
        "#7579FF"
      ];
    case 'misc':
      return [
        '#2b5876',
        '#4e4376',
      ];
    case 'dev':
      return [
        '#ff0844',
        '#ffb199',
      ];
    default:
      return [];
  }
};
